import type { WebsiteHealthSummary } from "contracts/api/website/responses";
import { BenchmarkEditor } from "./BenchmarkEditor";
import { MetricCatalogEditor } from "./MetricCatalogEditor";

// Reference-data curation drawer behind the shared-secret gate: edit the global
// metric catalog and per-website peer benchmarks. Opened from the landing page.
export function AdminPanel(props: {
  websites: WebsiteHealthSummary[];
  onClose: () => void;
}) {
  return (
    <div class="scrim scrim-right">
      <aside class="drawer drawer-wide">
        <div class="drawer-head">
          <h3 class="drawer-title">Admin</h3>
          <button
            class="icon-btn"
            type="button"
            aria-label="Close"
            onClick={props.onClose}
          >
            ✕
          </button>
        </div>
        <div class="drawer-body">
          <MetricCatalogEditor />
          <BenchmarkEditor websites={props.websites} />
        </div>
      </aside>
    </div>
  );
}
